import { styles } from "./CreatUserStyles";
import { permissionNames } from "../../consts/constants";

export const columns = [
  {
    label: "FirstName*",
    name: "first_name",
    component: "TextField",
    type: "text",
    required: true,
    isTextTransform: true,
  },
  {
    label: "LastName*",
    name: "last_name",
    component: "TextField",
    type: "text",
    required: true,
    isTextTransform: true,
  },
  {
    label: "Email*",
    name: "email",
    component: "TextField",
    type: "email",
    required: true,
  },
  {
    label: "Password*",
    name: "password",
    component: "TextField",
    required: true,
    type: "password",
    autoCompleteOff: true,
    hasEyeIcon: true,
  },
  {
    label: "Phone*",
    name: "phone_number",
    component: "TextField",
    required: true,
  },
];

export const checkBoxGroup = [
  {
    name: permissionNames.account,
    label: "Accounts",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.masterOfOralImplantologyProgram,
    label: "Master of Oral Implantology Program",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.externship,
    label: "Live-Patient Externships - Participation Track",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.observationTrack,
    label: "Live-Patient Externships - Observation Track",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.dentalAssistantObservationTrack,
    label: "Live-Patient Externships - Dental Assistant Observation Track",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.cadaverProgram,
    label: "Hands-On Cadaver Programs",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.onlineProgram,
    label: "Online Programs",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.onlineProgramTestAttempts,
    label: "Users Test Attempts",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.purchaseOnlinePrograms,
    label: "Purchased Programs",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.subscriptions,
    label: "Subscriptions",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.speakers,
    label: "Speakers",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.saasAdmin,
    label: "Saas",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.user,
    label: "Users",
    component: "CheckBox",
    noLabel: true,
  },
  {
    name: permissionNames.deleteAccount,
    label: "Delete Account",
    component: "CheckBox",
    noLabel: true,
    customLabelStyles: styles.orangeCheckBoxLabel,
  },
  {
    name: permissionNames.deleteCourse,
    label: "Delete Courses",
    component: "CheckBox",
    noLabel: true,
    customLabelStyles: styles.orangeCheckBoxLabel,
  },
  {
    name: permissionNames.deleteSaaS,
    label: "Delete Saas",
    component: "CheckBox",
    noLabel: true,
    customLabelStyles: styles.orangeCheckBoxLabel,
  },
  {
    name: permissionNames.deleteCategories,
    label: "Delete Categories",
    component: "CheckBox",
    noLabel: true,
    customLabelStyles: styles.orangeCheckBoxLabel,
  },
  {
    name: permissionNames.deleteUser,
    label: "Delete User",
    component: "CheckBox",
    noLabel: true,
    customLabelStyles: styles.orangeCheckBoxLabel,
  },
];

export const formFields = {
  first_name: "",
  last_name: "",
  email: "",
  password: "",
  phone_number: "",
  [permissionNames.account]: false,
  [permissionNames.masterOfOralImplantologyProgram]: false,
  [permissionNames.externship]: false,
  [permissionNames.observationTrack]: false,
  [permissionNames.dentalAssistantObservationTrack]: false,
  [permissionNames.cadaverProgram]: false,
  [permissionNames.onlineProgram]: false,
  [permissionNames.onlineProgramTestAttempts]: false,
  [permissionNames.purchaseOnlinePrograms]: false,
  [permissionNames.subscriptions]: false,
  [permissionNames.speakers]: false,
  [permissionNames.saasAdmin]: false,
  [permissionNames.user]: false,
  [permissionNames.deleteAccount]: false,
  [permissionNames.deleteCourse]: false,
  [permissionNames.deleteSaaS]: false,
  [permissionNames.deleteCategories]: false,
  [permissionNames.deleteUser]: false,
};
